export const emailDialogIndexEnums = {
  ERROR: 'ERROR',
  LOADING: 'LOADING',
  OPENING: 'OPENING_PAGE_ONE',
  SUBMIT: 'EMAIL_VERIFICATION_OR_CREATION_PAGE_TWO',
  PENDING: 'EMAIL_VERIFICATION_SENT_THREE',
  SUCCESS: 'EMAIL_VERIFICATION_SUCCESS',
};
